export const illustrationSizes = {
  small: 44,
  medium: 100,
  standard: 152,
  large: 180,
  xlarge: 210
} as const;

export type IllustrationSize = keyof typeof illustrationSizes;
